// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"fa642af3","707":"f5eb8564","736":"976d51c4"}[chunkId] + ".chunk.js";
};